import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    staticClass: "catalog-admin"
  }, [_c('section', {
    staticClass: "catalog-hero"
  }, [_vm._m(0), _c('div', {
    staticClass: "catalog-hero__actions"
  }, [_c('span', {
    staticClass: "catalog-status",
    class: _vm.configuration.ativo ? 'is-online' : 'is-offline'
  }, [_c('span', {
    staticClass: "catalog-status__dot"
  }), _vm._v(" " + _vm._s(_vm.configuration.ativo ? "Catálogo ativo" : "Catálogo pausado") + " ")]), _c('button', {
    staticClass: "catalog-button catalog-button--ghost",
    attrs: {
      "type": "button",
      "disabled": !_vm.configuration.public_url
    },
    on: {
      "click": _vm.openPublicCatalog
    }
  }, [_c('i', {
    staticClass: "la la-external-link-alt"
  }), _vm._v(" Abrir vitrine ")]), _vm.activeTab === 'appearance' ? _c('button', {
    staticClass: "catalog-button catalog-button--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.savingConfiguration || _vm.loadingConfiguration
    },
    on: {
      "click": _vm.saveConfiguration
    }
  }, [_vm.savingConfiguration ? _c('span', {
    staticClass: "catalog-spinner"
  }) : _c('i', {
    staticClass: "la la-check"
  }), _vm._v(" " + _vm._s(_vm.savingConfiguration ? "Salvando..." : "Salvar e publicar") + " ")]) : _vm._e()])]), _c('nav', {
    staticClass: "catalog-tabs",
    attrs: {
      "aria-label": "Configurações do catálogo"
    }
  }, [_c('button', {
    class: {
      active: _vm.activeTab === 'appearance'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'appearance';
      }
    }
  }, [_vm._m(1), _vm._m(2)]), _c('button', {
    class: {
      active: _vm.activeTab === 'promotions'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'promotions';
      }
    }
  }, [_vm._m(3), _vm._m(4), _c('span', {
    staticClass: "catalog-tab-count"
  }, [_vm._v(_vm._s(_vm.promotions.length))])]), _c('button', {
    class: {
      active: _vm.activeTab === 'products'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'products';
      }
    }
  }, [_vm._m(5), _vm._m(6)]), _c('button', {
    class: {
      active: _vm.activeTab === 'configs'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'configs';
      }
    }
  }, [_vm._m(7), _vm._m(8)])]), _vm.activeTab === 'appearance' ? _c('section', {
    staticClass: "catalog-workspace"
  }, [_c('div', {
    staticClass: "catalog-form-stack"
  }, [_c('article', {
    staticClass: "catalog-panel catalog-publish-panel"
  }, [_c('div', {
    staticClass: "catalog-panel__heading"
  }, [_vm._m(9), _c('label', {
    staticClass: "catalog-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.configuration.ativo,
      expression: "configuration.ativo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.configuration.ativo) ? _vm._i(_vm.configuration.ativo, null) > -1 : _vm.configuration.ativo
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.configuration.ativo,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.configuration, "ativo", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.configuration, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.configuration, "ativo", $$c);
        }
      }
    }
  }), _vm._m(10), _c('span', [_vm._v(_vm._s(_vm.configuration.ativo ? "Ativo" : "Pausado"))])])]), _vm.loadingConfiguration ? _c('div', {
    staticClass: "catalog-loading-block"
  }, [_c('span', {
    staticClass: "catalog-spinner catalog-spinner--dark"
  }), _vm._v(" Carregando configurações... ")]) : _c('div', {
    staticClass: "catalog-fields-grid"
  }, [_c('label', {
    staticClass: "catalog-field catalog-field--wide"
  }, [_vm._m(11), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.configuration.nome,
      expression: "configuration.nome",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "maxlength": "100",
      "placeholder": "Ex.: Casa Aurora"
    },
    domProps: {
      "value": _vm.configuration.nome
    },
    on: {
      "blur": [_vm.fillSlugFromName, function ($event) {
        return _vm.$forceUpdate();
      }],
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.configuration, "nome", $event.target.value.trim());
      }
    }
  }), _vm.fieldError('nome') ? _c('small', {
    staticClass: "catalog-error"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("nome")) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "catalog-field catalog-field--wide"
  }, [_vm._m(12), _c('div', {
    staticClass: "catalog-slug-input"
  }, [_c('span', [_vm._v("/")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.configuration.slug,
      expression: "configuration.slug",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "maxlength": "80",
      "placeholder": "casa-aurora"
    },
    domProps: {
      "value": _vm.configuration.slug
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.configuration, "slug", $event.target.value.trim());
      }, _vm.normalizeSlug],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.fieldError('slug') ? _c('small', {
    staticClass: "catalog-error"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("slug")) + " ")]) : _c('small', [_vm._v("Use letras minúsculas, números e hífens.")])]), _c('label', {
    staticClass: "catalog-field catalog-field--wide"
  }, [_c('span', [_vm._v("Descrição da loja")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.configuration.descricao,
      expression: "configuration.descricao",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "rows": "3",
      "maxlength": "280",
      "placeholder": "Conte em poucas palavras o que torna sua loja especial."
    },
    domProps: {
      "value": _vm.configuration.descricao
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.configuration, "descricao", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', [_vm._v(_vm._s(_vm.configuration.descricao.length) + "/280 caracteres")])])])]), _c('article', {
    staticClass: "catalog-panel"
  }, [_vm._m(13), _c('div', {
    staticClass: "catalog-assets-grid"
  }, [_c('div', {
    staticClass: "catalog-asset-card"
  }, [_c('div', {
    staticClass: "catalog-asset-preview catalog-asset-preview--logo"
  }, [_vm.previewLogo ? _c('img', {
    attrs: {
      "src": _vm.previewLogo,
      "alt": "Prévia do logo"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.storeInitials))])]), _c('div', {
    staticClass: "catalog-asset-copy"
  }, [_c('strong', [_vm._v("Logo da loja")]), _c('small', [_vm._v("PNG, JPG ou WebP · recomendado 600 × 600 px")]), _c('div', {
    staticClass: "catalog-asset-actions"
  }, [_c('input', {
    ref: "logoInput",
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/webp"
    },
    on: {
      "change": function change($event) {
        return _vm.selectAsset('logo', $event);
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.logoInput.click();
      }
    }
  }, [_c('i', {
    staticClass: "la la-upload"
  }), _vm._v(" Escolher arquivo ")]), _vm.assets.logoFile ? _c('button', {
    staticClass: "is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.clearAsset('logo');
      }
    }
  }, [_vm._v(" Remover ")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.configuration.logo_url,
      expression: "configuration.logo_url",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "catalog-url-input",
    attrs: {
      "type": "url",
      "placeholder": "ou cole a URL do logo"
    },
    domProps: {
      "value": _vm.configuration.logo_url
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.configuration, "logo_url", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "catalog-asset-card"
  }, [_c('div', {
    staticClass: "catalog-asset-preview catalog-asset-preview--cover",
    style: _vm.coverPreviewStyle
  }, [!_vm.previewCover ? _c('span', [_c('i', {
    staticClass: "la la-image"
  })]) : _vm._e()]), _c('div', {
    staticClass: "catalog-asset-copy"
  }, [_c('strong', [_vm._v("Foto de capa")]), _c('small', [_vm._v("PNG, JPG ou WebP · recomendado 1600 × 700 px")]), _c('div', {
    staticClass: "catalog-asset-actions"
  }, [_c('input', {
    ref: "coverInput",
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/webp"
    },
    on: {
      "change": function change($event) {
        return _vm.selectAsset('cover', $event);
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.coverInput.click();
      }
    }
  }, [_c('i', {
    staticClass: "la la-upload"
  }), _vm._v(" Escolher arquivo ")]), _vm.assets.coverFile ? _c('button', {
    staticClass: "is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.clearAsset('cover');
      }
    }
  }, [_vm._v(" Remover ")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.configuration.capa_url,
      expression: "configuration.capa_url",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "catalog-url-input",
    attrs: {
      "type": "url",
      "placeholder": "ou cole a URL da foto de capa"
    },
    domProps: {
      "value": _vm.configuration.capa_url
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.configuration, "capa_url", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])])]), _c('article', {
    staticClass: "catalog-panel"
  }, [_vm._m(14), _c('div', {
    staticClass: "catalog-presets"
  }, _vm._l(_vm.themePresets, function (preset) {
    return _c('button', {
      key: preset.id,
      class: {
        selected: _vm.isPresetSelected(preset)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.applyPreset(preset);
        }
      }
    }, [_c('span', {
      staticClass: "catalog-preset-colors"
    }, [_c('i', {
      style: {
        background: preset.tema.cor_primaria
      }
    }), _c('i', {
      style: {
        background: preset.tema.cor_secundaria
      }
    }), _c('i', {
      style: {
        background: preset.tema.cor_fundo
      }
    })]), _c('span', [_c('strong', [_vm._v(_vm._s(preset.nome))]), _c('small', [_vm._v(_vm._s(preset.descricao))])]), _vm.isPresetSelected(preset) ? _c('i', {
      staticClass: "la la-check-circle"
    }) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "catalog-colors-grid"
  }, _vm._l(_vm.themeColors, function (color) {
    return _c('label', {
      key: color.key,
      staticClass: "catalog-color-field"
    }, [_c('span', [_vm._v(_vm._s(color.label))]), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.configuration.tema[color.key],
        expression: "configuration.tema[color.key]"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": _vm.configuration.tema[color.key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.configuration.tema, color.key, $event.target.value);
        }
      }
    }), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: _vm.configuration.tema[color.key],
        expression: "configuration.tema[color.key]",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text",
        "maxlength": "7"
      },
      domProps: {
        "value": _vm.configuration.tema[color.key]
      },
      on: {
        "blur": [function ($event) {
          return _vm.validateThemeColor(color.key);
        }, function ($event) {
          return _vm.$forceUpdate();
        }],
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.configuration.tema, color.key, $event.target.value.trim());
        }
      }
    })])]);
  }), 0), _c('div', {
    staticClass: "catalog-style-grid"
  }, [_c('label', {
    staticClass: "catalog-field"
  }, [_c('span', [_vm._v("Estilo dos produtos")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.configuration.tema.estilo_card,
      expression: "configuration.tema.estilo_card"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.configuration.tema, "estilo_card", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "suave"
    }
  }, [_vm._v("Cards suaves")]), _c('option', {
    attrs: {
      "value": "linha"
    }
  }, [_vm._v("Contorno editorial")]), _c('option', {
    attrs: {
      "value": "elevado"
    }
  }, [_vm._v("Cards elevados")])])]), _c('label', {
    staticClass: "catalog-field"
  }, [_c('span', [_vm._v("Estilo dos botões")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.configuration.tema.estilo_botao,
      expression: "configuration.tema.estilo_botao"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.configuration.tema, "estilo_botao", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "arredondado"
    }
  }, [_vm._v("Arredondados")]), _c('option', {
    attrs: {
      "value": "pill"
    }
  }, [_vm._v("Formato cápsula")]), _c('option', {
    attrs: {
      "value": "reto"
    }
  }, [_vm._v("Cantos discretos")])])])])])]), _c('aside', {
    staticClass: "catalog-preview-column"
  }, [_vm._m(15), _c('div', {
    staticClass: "catalog-phone"
  }, [_c('div', {
    staticClass: "catalog-phone__speaker"
  }), _c('div', {
    staticClass: "catalog-phone__screen",
    style: {
      background: _vm.configuration.tema.cor_fundo
    }
  }, [_c('div', {
    staticClass: "catalog-store-cover",
    style: _vm.coverPreviewStyle
  }, [_c('div', {
    staticClass: "catalog-store-cover__shade"
  }), _c('div', {
    staticClass: "catalog-store-logo",
    style: {
      background: _vm.configuration.tema.cor_primaria
    }
  }, [_vm.previewLogo ? _c('img', {
    attrs: {
      "src": _vm.previewLogo,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.storeInitials))])])]), _c('div', {
    staticClass: "catalog-store-info"
  }, [_c('span', {
    staticClass: "catalog-store-open"
  }, [_vm._v("● catálogo online")]), _c('h3', {
    style: {
      color: _vm.configuration.tema.cor_texto
    }
  }, [_vm._v(" " + _vm._s(_vm.configuration.nome || "Sua loja") + " ")]), _c('p', {
    style: {
      color: _vm.configuration.tema.cor_texto
    }
  }, [_vm._v(" " + _vm._s(_vm.configuration.descricao || "Produtos escolhidos com carinho para você.") + " ")])]), _vm._m(16), _c('div', {
    staticClass: "catalog-preview-chips"
  }, [_c('span', {
    style: {
      color: _vm.configuration.tema.cor_primaria,
      borderColor: _vm.configuration.tema.cor_primaria
    }
  }, [_vm._v("Todos")]), _c('span', [_vm._v("Novidades")]), _c('span', [_vm._v("Mais vendidos")])]), _c('div', {
    staticClass: "catalog-preview-products"
  }, _vm._l(_vm.previewProducts, function (item) {
    return _c('div', {
      key: item.name,
      staticClass: "catalog-preview-product",
      class: "card-".concat(_vm.configuration.tema.estilo_card)
    }, [_c('div', {
      style: {
        background: item.color
      }
    }, [_c('span', [_vm._v(_vm._s(item.emoji))])]), _c('small', [_vm._v(_vm._s(item.tag))]), _c('strong', {
      style: {
        color: _vm.configuration.tema.cor_texto
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('p', [_vm._v(_vm._s(item.price))]), _c('button', {
      class: "button-".concat(_vm.configuration.tema.estilo_botao),
      style: {
        background: _vm.configuration.tema.cor_primaria,
        color: _vm.buttonTextColor
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(" Adicionar ")])]);
  }), 0)])]), _vm._m(17)])]) : _vm.activeTab === 'promotions' ? _c('section', {
    staticClass: "catalog-promotions-workspace"
  }, [_c('div', {
    staticClass: "catalog-promotions-summary"
  }, [_c('div', [_vm._m(18), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.activePromotionsCount))]), _vm._v(" promoções ativas agora ")])]), _c('div', [_vm._m(19), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.scheduledPromotionsCount))]), _vm._v(" ofertas agendadas ")])]), _c('p', [_vm._v(" As ofertas entram e saem da vitrine automaticamente conforme o período configurado. ")])]), _c('div', {
    staticClass: "catalog-promotions-grid"
  }, [_c('article', {
    staticClass: "catalog-panel catalog-promotion-form"
  }, [_c('div', {
    staticClass: "catalog-panel__heading"
  }, [_c('div', [_vm._m(20), _c('div', [_c('h2', [_vm._v(" " + _vm._s(_vm.promotionForm.id ? "Editar promoção" : "Nova promoção") + " ")]), _c('p', [_vm._v("Programe uma oferta para um produto do catálogo.")])])]), _vm.promotionForm.id ? _c('button', {
    staticClass: "catalog-text-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPromotionForm
    }
  }, [_vm._v(" Cancelar edição ")]) : _vm._e()]), _vm.loadingProducts ? _c('div', {
    staticClass: "catalog-loading-block"
  }, [_c('span', {
    staticClass: "catalog-spinner catalog-spinner--dark"
  }), _vm._v(" Carregando produtos do catálogo... ")]) : _c('div', {
    staticClass: "catalog-fields-grid"
  }, [_c('label', {
    staticClass: "catalog-field catalog-field--wide"
  }, [_vm._m(21), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.id_produto,
      expression: "promotionForm.id_produto"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "id_produto", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione um produto")]), _vm._l(_vm.products, function (product) {
    return _c('option', {
      key: product.id,
      domProps: {
        "value": product.id
      }
    }, [_vm._v(" " + _vm._s(product.descricao) + " · " + _vm._s(_vm.formatMoney(product.valor_venda)) + " ")]);
  })], 2), _vm.promotionError('id_produto') ? _c('small', {
    staticClass: "catalog-error"
  }, [_vm._v(" " + _vm._s(_vm.promotionError("id_produto")) + " ")]) : !_vm.products.length ? _c('small', [_vm._v(" Ative “Catálogo digital” nos produtos que deseja promover. ")]) : _vm._e()]), _c('label', {
    staticClass: "catalog-field catalog-field--wide"
  }, [_vm._m(22), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.promotionForm.nome,
      expression: "promotionForm.nome",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "maxlength": "100",
      "placeholder": "Ex.: Semana do cliente"
    },
    domProps: {
      "value": _vm.promotionForm.nome
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "nome", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.promotionError('nome') ? _c('small', {
    staticClass: "catalog-error"
  }, [_vm._v(" " + _vm._s(_vm.promotionError("nome")) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "catalog-field"
  }, [_c('span', [_vm._v("Tipo de oferta")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.tipo,
      expression: "promotionForm.tipo"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "percentual"
    }
  }, [_vm._v("Desconto percentual")]), _c('option', {
    attrs: {
      "value": "valor_fixo"
    }
  }, [_vm._v("Desconto em reais")])])]), _c('label', {
    staticClass: "catalog-field"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.promotionForm.tipo === "percentual" ? "Percentual" : "Valor") + " "), _c('em', [_vm._v("obrigatório")])]), _c('div', {
    staticClass: "catalog-value-input"
  }, [_c('span', [_vm._v(_vm._s(_vm.promotionForm.tipo === "percentual" ? "%" : "R$"))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.promotionForm.valor,
      expression: "promotionForm.valor",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "0,00"
    },
    domProps: {
      "value": _vm.promotionForm.valor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "valor", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.promotionError('valor') ? _c('small', {
    staticClass: "catalog-error"
  }, [_vm._v(" " + _vm._s(_vm.promotionError("valor")) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "catalog-field"
  }, [_c('span', [_vm._v("Começa em")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.inicio_em,
      expression: "promotionForm.inicio_em"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": _vm.promotionForm.inicio_em
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "inicio_em", $event.target.value);
      }
    }
  })]), _c('label', {
    staticClass: "catalog-field"
  }, [_c('span', [_vm._v("Termina em")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.fim_em,
      expression: "promotionForm.fim_em"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": _vm.promotionForm.fim_em
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "fim_em", $event.target.value);
      }
    }
  }), _vm.promotionError('fim_em') ? _c('small', {
    staticClass: "catalog-error"
  }, [_vm._v(" " + _vm._s(_vm.promotionError("fim_em")) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "catalog-field catalog-field--wide"
  }, [_c('span', [_vm._v("Mensagem opcional")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.promotionForm.descricao,
      expression: "promotionForm.descricao",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "rows": "2",
      "maxlength": "180",
      "placeholder": "Uma chamada curta para destacar a oferta."
    },
    domProps: {
      "value": _vm.promotionForm.descricao
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "descricao", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "catalog-promotion-switches catalog-field--wide"
  }, [_c('label', {
    staticClass: "catalog-check-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.ativo,
      expression: "promotionForm.ativo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.promotionForm.ativo) ? _vm._i(_vm.promotionForm.ativo, null) > -1 : _vm.promotionForm.ativo
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.promotionForm.ativo,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.promotionForm, "ativo", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.promotionForm, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.promotionForm, "ativo", $$c);
        }
      }
    }
  }), _vm._m(23)]), _c('label', {
    staticClass: "catalog-check-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.destaque,
      expression: "promotionForm.destaque"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.promotionForm.destaque) ? _vm._i(_vm.promotionForm.destaque, null) > -1 : _vm.promotionForm.destaque
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.promotionForm.destaque,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.promotionForm, "destaque", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.promotionForm, "destaque", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.promotionForm, "destaque", $$c);
        }
      }
    }
  }), _vm._m(24)])]), _c('button', {
    staticClass: "catalog-button catalog-button--primary catalog-field--wide",
    attrs: {
      "type": "button",
      "disabled": _vm.savingPromotion || !_vm.products.length
    },
    on: {
      "click": _vm.savePromotion
    }
  }, [_vm.savingPromotion ? _c('span', {
    staticClass: "catalog-spinner"
  }) : _c('i', {
    staticClass: "la la-calendar-check"
  }), _vm._v(" " + _vm._s(_vm.savingPromotion ? "Salvando..." : _vm.promotionForm.id ? "Atualizar promoção" : "Agendar promoção") + " ")])])]), _c('article', {
    staticClass: "catalog-panel catalog-promotion-list-panel"
  }, [_c('div', {
    staticClass: "catalog-panel__heading"
  }, [_vm._m(25), _c('button', {
    staticClass: "catalog-icon-button",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingPromotions,
      "title": "Atualizar lista"
    },
    on: {
      "click": _vm.loadPromotions
    }
  }, [_c('i', {
    staticClass: "la la-sync"
  })])]), _vm.loadingPromotions ? _c('div', {
    staticClass: "catalog-loading-block"
  }, [_c('span', {
    staticClass: "catalog-spinner catalog-spinner--dark"
  }), _vm._v(" Carregando promoções... ")]) : !_vm.promotions.length ? _c('div', {
    staticClass: "catalog-empty-state"
  }, [_vm._m(26), _c('h3', [_vm._v("Sua primeira oferta começa aqui")]), _c('p', [_vm._v("Selecione um produto ao lado e programe a campanha.")])]) : _c('div', {
    staticClass: "catalog-promotion-list"
  }, _vm._l(_vm.promotions, function (promotion) {
    return _c('div', {
      key: promotion.id,
      staticClass: "catalog-promotion-card"
    }, [_c('div', {
      staticClass: "catalog-promotion-card__visual"
    }, [_vm.promotionProduct(promotion).imagem ? _c('img', {
      attrs: {
        "src": _vm.promotionProduct(promotion).imagem,
        "alt": ""
      }
    }) : _c('i', {
      staticClass: "la la-shopping-bag"
    }), promotion.destaque ? _c('span', [_vm._v("Destaque")]) : _vm._e()]), _c('div', {
      staticClass: "catalog-promotion-card__body"
    }, [_c('div', {
      staticClass: "catalog-promotion-card__topline"
    }, [_c('span', {
      staticClass: "catalog-promotion-state",
      class: "is-".concat(_vm.promotionStatus(promotion))
    }, [_vm._v(" " + _vm._s(_vm.promotionStatusLabel(promotion)) + " ")]), _c('div', [_c('button', {
      attrs: {
        "type": "button",
        "title": "Editar promoção"
      },
      on: {
        "click": function click($event) {
          return _vm.editPromotion(promotion);
        }
      }
    }, [_c('i', {
      staticClass: "la la-pen"
    })]), _c('button', {
      attrs: {
        "type": "button",
        "title": "Excluir promoção",
        "disabled": _vm.deletingPromotionId === promotion.id
      },
      on: {
        "click": function click($event) {
          return _vm.removePromotion(promotion);
        }
      }
    }, [_vm.deletingPromotionId === promotion.id ? _c('span', {
      staticClass: "catalog-spinner catalog-spinner--dark"
    }) : _c('i', {
      staticClass: "la la-trash"
    })])])]), _c('h3', [_vm._v(_vm._s(promotion.nome))]), _c('p', [_vm._v(_vm._s(_vm.promotionProduct(promotion).descricao))]), _c('strong', {
      staticClass: "catalog-promotion-value"
    }, [_vm._v(" " + _vm._s(_vm.promotionValueLabel(promotion)) + " ")]), _c('small', [_c('i', {
      staticClass: "la la-calendar"
    }), _vm._v(" " + _vm._s(_vm.promotionPeriodLabel(promotion)) + " ")])])]);
  }), 0)])])]) : _vm._e(), _c('CatalogoDigitalProductsTab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab === 'products',
      expression: "activeTab === 'products'"
    }],
    ref: "productsTab",
    on: {
      "published": _vm.handleProductsPublished
    }
  }), _c('CatalogoDigitalSettingsTab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab === 'configs',
      expression: "activeTab === 'configs'"
    }],
    attrs: {
      "active": _vm.activeTab === 'configs'
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "catalog-hero__content"
  }, [_c('span', {
    staticClass: "catalog-eyebrow"
  }, [_vm._v("NOVO CANAL DE VENDAS")]), _c('h1', [_vm._v("Sua vitrine digital, do seu jeito.")]), _c('p', [_vm._v(" Publique produtos do ERP, apresente suas melhores ofertas e receba pedidos sem duplicar cadastros. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-tab-icon"
  }, [_c('i', {
    staticClass: "la la-paint-brush"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Aparência e publicação")]), _c('small', [_vm._v("Marca, endereço e estilo da vitrine")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-tab-icon"
  }, [_c('i', {
    staticClass: "la la-tags"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Promoções")]), _c('small', [_vm._v("Ofertas programadas por produto")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-tab-icon"
  }, [_c('i', {
    staticClass: "la la-box"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Produtos")]), _c('small', [_vm._v("Fotos e itens publicados na vitrine")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-tab-icon"
  }, [_c('i', {
    staticClass: "la la-sliders-h"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Configurações")]), _c('small', [_vm._v("Regras e padrões")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "catalog-section-number"
  }, [_vm._v("01")]), _c('div', [_c('h2', [_vm._v("Publicação")]), _c('p', [_vm._v("Defina a identidade e o endereço público do catálogo.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-toggle__track"
  }, [_c('span', {
    staticClass: "catalog-toggle__thumb"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v("Nome da loja "), _c('em', [_vm._v("obrigatório")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v("Endereço do catálogo "), _c('em', [_vm._v("obrigatório")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "catalog-panel__heading"
  }, [_c('div', [_c('span', {
    staticClass: "catalog-section-number"
  }, [_vm._v("02")]), _c('div', [_c('h2', [_vm._v("Imagens da marca")]), _c('p', [_vm._v("Envie arquivos ou use imagens já hospedadas.")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "catalog-panel__heading"
  }, [_c('div', [_c('span', {
    staticClass: "catalog-section-number"
  }, [_vm._v("03")]), _c('div', [_c('h2', [_vm._v("Estilo da vitrine")]), _c('p', [_vm._v("Escolha uma base e personalize as cores da sua marca.")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "catalog-preview-heading"
  }, [_c('div', [_c('span', [_vm._v("PRÉ-VISUALIZAÇÃO")]), _c('strong', [_vm._v("Atualiza enquanto você edita")])]), _c('span', {
    staticClass: "catalog-device-pill"
  }, [_c('i', {
    staticClass: "la la-mobile"
  }), _vm._v(" Mobile")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "catalog-preview-search"
  }, [_c('i', {
    staticClass: "la la-search"
  }), _vm._v(" Buscar no catálogo ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "catalog-preview-tip"
  }, [_c('i', {
    staticClass: "la la-lightbulb"
  }), _c('p', [_c('strong', [_vm._v("Dica de vitrine")]), _vm._v(" Use fotos claras e mantenha os nomes dos produtos curtos. Isso facilita a escolha no celular. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-summary-icon"
  }, [_c('i', {
    staticClass: "la la-bolt"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-summary-icon is-soft"
  }, [_c('i', {
    staticClass: "la la-clock"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "catalog-section-number"
  }, [_c('i', {
    staticClass: "la la-plus"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v("Produto "), _c('em', [_vm._v("obrigatório")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v("Nome da campanha "), _c('em', [_vm._v("obrigatório")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Promoção ativa")]), _c('small', [_vm._v("Pode aparecer na vitrine dentro do período.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Destacar na vitrine")]), _c('small', [_vm._v("Use para sua oferta mais importante.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "catalog-section-number"
  }, [_c('i', {
    staticClass: "la la-list"
  })]), _c('div', [_c('h2', [_vm._v("Campanhas configuradas")]), _c('p', [_vm._v("Acompanhe o calendário de ofertas da loja.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "la la-tags"
  })]);
}];
export { render, staticRenderFns };